import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardBody, Col, Row, Spinner, Button } from "reactstrap";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const LiveStationCycleTime = () => {
  const [stations, setStations] = useState([]);
  const [loading, setLoading] = useState(false);

  const getTodayDate = () => {
    const now = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istTime = new Date(now.getTime() + istOffset);
    return istTime.toISOString().split("T")[0];
  };

  const today = getTodayDate();

  const fetchStationCycleTime = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `https://api.hanoch.in/api/mcc-data/?machine_id=74&date=${today}`
      );

      setStations(res?.st_values || []);
    } catch (err) {
      console.error("Station cycle time error:", err);
      setStations([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStationCycleTime();
    const interval = setInterval(fetchStationCycleTime, 60000); // every 1 min
    return () => clearInterval(interval);
  }, []); // 🔥 no dependency needed

  return (
    <Card className="">
      <CardBody>
        <h5 className="fw-bold text-center mb-3">
          STATION CYCLE TIME
        </h5>

        {loading ? (
          <div className="text-center py-4">
            <Spinner size="sm" />
          </div>
        ) : (
          <Row className="mt-4">
            {stations.map((station, index) => (
              <Col xl={2} lg={2} md={3} sm={4} xs={6} key={index}>
                <div
                  style={{
                    border: "1px solid #475569",
                    borderRadius: "6px",
                    padding: "10px",
                    // backgroundColor: "#1e293b",
                    textAlign: "center",
                  }}
                >
                  <div className="text-secondary" style={{ fontSize: 12 }}>
                    {station.key}
                  </div>
                  <div className="text-bold fs-5">
                    {station.value}s
                  </div>
                </div>
                <br />
              </Col>
            ))}
          </Row>
        )}
      </CardBody>
    </Card>
  );
};


export default LiveStationCycleTime;
